import React from "react";
import { Box, Typography } from "@mui/material";
import { INDIGO } from "../constants/Colors";

export default function VariableChip({ name }) {
  return (
    <Box sx={{
      display: "inline-flex",
      alignItems: "center",
      px: "8px",
      py: "3px",
      bgcolor: INDIGO[50],
      border: `1px solid ${INDIGO[200]}`,
      borderRadius: "6px",
      flexShrink: 0,
    }}>
      <Typography sx={{
        fontSize: "0.6875rem",
        fontFamily: "monospace",
        fontWeight: 600,
        color: INDIGO[600],
        letterSpacing: "0.01em",
      }}>
        {`{{${name}}}`}
      </Typography>
    </Box>
  );
}
